export interface IModelBase {

    tag?: any;

    assign?: (source: IModelBase) => void;
    clone?: () => IModelBase;
    initializeAsync?: () => Promise<void>;
    removeReferences?: () => void;
    setReferences?: () => void;
    toJSON?: () => any;

}
